import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const DISCLAIMER =
  "The information may be inaccurate or out of date and is to be used as an adjunct to individual study only.";

export const DisclaimerBanner = () => (
  <div
    data-testid="disclaimer-banner"
    className="flex items-start gap-3 rounded-xl px-4 py-3 text-sm"
    style={{ background: "color-mix(in srgb, var(--warn) 12%, transparent)", border: "1px solid color-mix(in srgb, var(--warn) 35%, transparent)" }}
  >
    <ShieldAlert size={18} className="shrink-0 mt-0.5" style={{ color: "var(--warn)" }} />
    <p><strong className="font-semibold">Disclaimer:</strong> {DISCLAIMER}</p>
  </div>
);

export const DisclaimerGate = () => {
  const [open, setOpen] = useState(() => localStorage.getItem("disclaimer-ack") !== "1");
  const accept = () => {
    localStorage.setItem("disclaimer-ack", "1");
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent data-testid="disclaimer-dialog" className="[&>button]:hidden" style={{ background: "var(--surface)" }}>
        <DialogTitle className="font-display text-xl">Before you start</DialogTitle>
        <DialogDescription className="text-base leading-relaxed" style={{ color: "var(--ink-2)" }}>
          This is a free, unofficial practice tool for RGA AST SSSA viva preparation. {DISCLAIMER} It is not affiliated
          with ANZCA, ACRRM or RACGP.
        </DialogDescription>
        <div className="mt-2 flex">
          <button data-testid="disclaimer-accept-button" onClick={accept} className="btn-primary flex-1 h-11 rounded-full font-semibold">
            I understand
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
